exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  color: #e60000;\n  font-size: 1rem;\n  margin: 0; }\n\n.icon {\n  display: inline-block;\n  float: none; }\n\n.hint-section {\n  position: relative;\n  text-align: center;\n  height: 24px; }\n  .hint-section p {\n    position: absolute;\n    left: 0;\n    right: 0; }\n\n.confirm-text {\n  padding: 25px 45px 15px 45px;\n  text-align: center;\n  color: #9e9e9e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/patient-additional-details-modal/patient-additional-details-modal.component.scss
// module id = ../../../../../src/app/shared/components/patient-additional-details-modal/patient-additional-details-modal.component.scss
// module chunks = main